// extracted by mini-css-extract-plugin
module.exports = {"weHost":"calendar_weHost__2rDoE","registered":"calendar_registered__8shP5","other":"calendar_other__fDM37","past":"calendar_past__2uv99","hidden":"calendar_hidden__2R20K"};